import React, { useState } from 'react'
import { View } from 'react-native'

import Typography from '@ui/typography'

import { TileOptionProps } from '@ui/tiles/TileOption/types'

import PressableIcon from '@ui/buttons/PressableIcon'
import Popover from '@ui/components/Popover'
import AppConfig from 'config'
import useAnimatedToggle from '@ui/hooks/useAnimatedToggle'
import { useSharedValue } from 'react-native-reanimated'
import Glass from '@ui/elements/Glass'

const DebugItem = ({
  label,
  children,
}: {
  label?: string
  children?: string | number | null
}) => (
  <View className="flex flex-row gap-2">
    <Typography variant="SM" className="color-text">
      {label}
    </Typography>
    <Typography variant="SMB" className="color-text">
      {children}
    </Typography>
  </View>
)

const DebugView = ({ item }: { item: TileOptionProps }) => {
  const [open, setOpen] = useState(false)
  const animation = useAnimatedToggle(open)
  const width = useSharedValue(250)
  const toggle = () => {
    setOpen(!open)
  }
  return (
    <View className="absolute right-6 top-6 opacity-25">
      <Popover
        open={open}
        onClose={toggle}
        offset={8}
        position={['bottom', 'right']}
        customWidth={width}
        content={
          <Glass blur={50} className="flex flex-col gap-2 p-6">
            <DebugItem label="id">{item.id}</DebugItem>
            <DebugItem label="variantId">{item.variantId}</DebugItem>
            <DebugItem label="name">{item.name}</DebugItem>
            <DebugItem label="value">{item.value}</DebugItem>
          </Glass>
        }
      >
        <PressableIcon
          animation={animation}
          onPress={toggle}
          name="info-circle"
        />
      </Popover>
    </View>
  )
}

const TileOptionDebug = ({ item }: { item: TileOptionProps }) => {
  const isDebug =
    AppConfig.debug.steps || AppConfig.debug.all || AppConfig.isDev
  if (!isDebug) {
    return null
  }
  return <DebugView item={item} />
}

export default TileOptionDebug
